import qs from 'querystring';

import formatCalendarDate from './formatCalendarDate';

export default function buildOutlookCalendarUrl(calendarEvent) {
  const params = {
    rru: 'addevent',
    startdt: formatCalendarDate(calendarEvent.startTime),
    enddt: formatCalendarDate(calendarEvent.endTime),
    subject: calendarEvent.title,
    body: calendarEvent.description,
    location: calendarEvent.location,
    allday: 'false',
    path: '/calendar/view/Month',
  };
  return `https://outlook.live.com/owa/?${qs.stringify(params)}`;
}
